import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_site/legal")({
  component: () => <div className="container mx-auto max-w-3xl px-4 py-10 prose-sm prose-invert"><Outlet /></div>,
});
